import { initializeFaro, getWebInstrumentations, Faro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

let faroInstance: Faro | null = null;

const collectorUrl = process.env.REACT_APP_FARO_COLLECTOR_URL;

// Gate Faro init behind an explicit opt-in. Grafana Cloud's Faro app
// allowlists origins per app token — our prod token rejects payloads from
// PR-preview origins (stabletrack-staging-pr-NNN.onrender.com), which Chrome
// surfaces as a preflight CORS rejection on every collect POST. The console
// fills with "Failed to fetch" + "No 'Access-Control-Allow-Origin' header"
// pairs at the SDK's retry cadence and drowns out signal during testing.
//
// Set REACT_APP_FARO_ENABLED=true only on Render envs whose origin is
// actually allowlisted in the Grafana app config (i.e. prod). Leave it unset
// on PR previews and local dev — Faro stays silent, console stays clean.
const faroEnabled = process.env.REACT_APP_FARO_ENABLED === 'true';

if (collectorUrl && faroEnabled) {
  faroInstance = initializeFaro({
    url: collectorUrl,
    app: {
      name: 'stabletrack',
      version: process.env.REACT_APP_VERSION || '1.0.0',
      environment: process.env.NODE_ENV || 'development',
    },
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: false,
      }),
      new TracingInstrumentation(),
    ],
  });
}

export const faro = faroInstance;
